let navbarItems = document.querySelectorAll('.navbar__item');
let sections = document.querySelectorAll('.main-collection-wrapper');
let sectionTitles = document.querySelectorAll('.main-collection-subtitle');

const scrollToSection = event => {
    event.preventDefault();
    let targetSection = event.target.closest('.navbar__item').getAttribute('href').replace('#','');
    let isAllProducts = targetSection == '' ? true : false;

    //document.querySelector(`${targetSection}`).scrollIntoView({ behavior: 'smooth' });
    if (isAllProducts) {
      sections.forEach(el => { 
        el.classList.add('active');
        el.classList.remove('hide_border')
      });
    }else {
      sections.forEach(el => {
        el.id.indexOf(targetSection) > -1 ? el.classList.add('active', 'hide_border') : el.classList.remove('active');
      });
    }
   
    //Update title
    sectionTitles.forEach(el => {
      if (!isAllProducts) {
        if (el.dataset.navTitle == targetSection){
          el.textContent = el.dataset.titleSwap;
        }
      }else {
        el.textContent = el.dataset.titleDefault;
      }
    });

    navbarItems.forEach(el => {
        el == event.target.closest('.navbar__item') ? el.classList.add('active') : el.classList.remove('active');
    });
}

navbarItems.forEach(el => el.addEventListener('click', scrollToSection));


// // On scroll movement
// let lastId;
// let topMenu = document.querySelector(".collection__navbar-container");
// let topMenuHeight = topMenu.offsetHeight + 15;
// // All list items
// let menuItems = topMenu.querySelectorAll("a");
// // Anchors corresponding to menu items
// let scrollItems = Array.from(menuItems).map(function(item) {
//     let reference = item.getAttribute("href");
//     let matchedElement = document.querySelector(reference);
//     return matchedElement ? matchedElement : null;
// }).filter(item => item);

// // Bind to scroll
// window.addEventListener("scroll", function() {
//     // Get container scroll position
//     var fromTop = window.pageYOffset + topMenuHeight;
  
//     // Get id of current scroll item
//     var cur = scrollItems.filter(function(item) {
//       if (item.offsetTop < fromTop)
//         return item;
//     });
//     // Get the id of the current element
//     cur = cur[cur.length - 1];
//     var id = cur ? cur.id : "";
  
//     if (lastId !== id) {
//       lastId = id;
//       // Set/remove active class
//       Array.from(menuItems).forEach(function(item) {
//         if (item.getAttribute("href").includes("#" + id)) {
//           item.classList.add("active");
//         } else {
//           item.classList.remove("active");
//         }
//       });
//     }
// });